import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { createSelector } from "reselect";
import type { RootState } from 'redux/store';

import { getValidRequestedPathname } from 'utils/locationHelper';
import { getAndSetSellerById } from 'redux/sellers/actions';

const memoizedSelector = createSelector(
  (state: RootState) => state.sellers.currentSeller,
  (currentSeller) => ({ currentSeller })
);

const withSellerId = (Component: React.FC) => React.memo(() => {

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const { currentSeller } = useAppSelector(memoizedSelector)

    useEffect(() => {
      (async function() {
        const requestedPathname = getValidRequestedPathname(location.pathname, id);

        if(!id && currentSeller.info.data?.id) {
          return navigate(`/${currentSeller.info.data?.id}/${requestedPathname}`);
        }

        if(id && currentSeller.info.data?.id !== parseInt(id)) {
          dispatch(getAndSetSellerById(parseInt(id)) as any);
        }

      })();
      
    }, [currentSeller.info.data?.id])

    return (
        <Component />
    )
})

export default withSellerId;
